import * as React from 'react';
export const IcHotspot = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16 14H8a3 3 0 00-3 3v4a1 1 0 001 1h12a1 1 0 001-1v-4a3 3 0 00-3-3zm-.82-4.4a1 1 0 101.6-1.2 6 6 0 00-9.56 0 1 1 0 001.6 1.2 4 4 0 016.36 0zm4.26-4.27a10 10 0 00-14.88 0 1.002 1.002 0 001.49 1.34 8 8 0 0111.9 0 1 1 0 00.75.33 1 1 0 00.66-.26 1 1 0 00.08-1.41zM11 11a1 1 0 102 0 1 1 0 00-2 0z'
      fill='currentColor'
    />
  </svg>
);
